import { formatColumnLabel } from '~/lib/helpers';

import Table, { TableBody, TableCell, TableHead, TableRow } from '../Table';
import styles from './styles.styles';

const DynamicTable = ({
  columns,
  columnMapping,
  children,
  leftAligned,
  sidebar,
  actions,
  classes,
}) => {
  const renderLabel = (column) => {
    let label;

    if (columnMapping) {
      label = columnMapping[column];
    }

    if (column === 'company->domain') {
      label = 'Domain';
    }

    label = label || formatColumnLabel(column);

    return label;
  };

  const renderColumn = (column) => {
    const label = renderLabel(column);

    return (
      <TableCell key={column} title={label} ellipsis leftAligned={leftAligned}>
        {label}
      </TableCell>
    );
  };

  const renderColumns = () => {
    return columns.map(renderColumn);
  };

  return (
    <Table sidebar={sidebar} actions={actions}>
      {actions && <div className={classes.actions}>{actions}</div>}
      <TableHead leftAligned={leftAligned}>
        <TableRow>{renderColumns()}</TableRow>
      </TableHead>

      <TableBody>{children}</TableBody>
    </Table>
  );
};

DynamicTable.defaultProps = {
  leftAligned: false,
};

DynamicTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnMapping: PropTypes.object,
  children: PropTypes.element,
  leftAligned: PropTypes.bool,
};

export default withStyles(styles)(DynamicTable);
